import { DEFAULT_MESSAGE_FIELDS } from "views/Constants";
import { addWidget } from "views/logic/slices/widgetActions";
import MessagesWidget from "../widgets/MessagesWidget";
import MessagesWidgetConfig from "../widgets/MessagesWidgetConfig";
export const CreateMessagesWidget = () => MessagesWidget.builder().newId().config(
  MessagesWidgetConfig.builder().fields(DEFAULT_MESSAGE_FIELDS).showMessageRow(true).showSummary(true).build()
).build();
export default () => (dispatch) => dispatch(addWidget(CreateMessagesWidget()));
